import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgScrollbarModule } from 'ngx-scrollbar';
import {CoreCommonModule} from '@core/common.module';
import {CoreTouchspinModule} from '@core/components/core-touchspin/core-touchspin.module';

import {NavbarComponent} from 'app/core/layout/components/navbar/navbar.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [
    NavbarComponent
  ],
  imports: [RouterModule, NgbModule, CoreCommonModule, NgScrollbarModule, CoreTouchspinModule, TranslateModule],
  exports: [NavbarComponent]
})
export class NavbarModule {
}
